/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { func, string } from 'prop-types';
import editIcon from 'Assets/images/commons/editIcon.svg';

const EditIcon = ({ onClick, icon }) => {
  return (
    <img style={{ cursor: 'pointer' }} src={icon || editIcon} alt="edit icon" onClick={onClick} />
  );
};

EditIcon.propTypes = {
  onClick: func,
  icon: string,
};
EditIcon.defaultProps = {
  onClick: () => null,
  icon: '',
};

export default EditIcon;
